import { render } from "./PaisesView.vue?vue&type=template&id=338f4f75"
import script from "./PaisesView.vue?vue&type=script&lang=js"
export * from "./PaisesView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__